import React from 'react';
import OneWayInHistoryV2 from '../components/history/OneWayInHistoryV2';
import { useParams } from 'react-router-dom';
import { useOneWayIn } from '../..';
import { PageParams } from '../types/PageParams';

const ActivityLog: React.FC = () => {
  const { formId } = useParams<PageParams>();

  const { oneWayInOpportunityFormFullHistoryQuery } = useOneWayIn(formId);

  return (
    <>
      <OneWayInHistoryV2
        isLoading={oneWayInOpportunityFormFullHistoryQuery.isLoading}
        data={oneWayInOpportunityFormFullHistoryQuery.data || []}
        formId={formId || ''}
      />
    </>
  );
};

export default ActivityLog;
